import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={31}
    height={30}
    fill="none"
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={1}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      stroke="var(--filter-bar-btn-border)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.632 19.5c0-.276.277-.5.5-.5h9a.5.5 0 0 1 .5.5c0 .276-.276.5-.5.5h-9a.5.5 0 0 1-.5-.5ZM14.633 16.5c0-.276.276-.5.5-.5h8a.5.5 0 0 1 .5.5c0 .276-.277.5-.5.5h-8a.5.5 0 0 1-.5-.5ZM16.132 13.5c0-.276.276-.5.5-.5h6.5a.5.5 0 0 1 .5.5c0 .276-.276.5-.5.5h-6.5a.5.5 0 0 1-.5-.5ZM17.632 10.5c0-.276.276-.5.5-.5h5a.5.5 0 0 1 .5.5c0 .276-.276.5-.5.5h-5a.5.5 0 0 1-.5-.5ZM12.45 12.976c-.195.196-.549.159-.707 0l-2.121-2.12a.5.5 0 0 1 0-.708c.195-.195.549-.158.707 0l2.121 2.121a.5.5 0 0 1 0 .707Z"
      fill="var(--filter-bar-btn-border)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 12.977c-.195-.196-.158-.55 0-.708l2.122-2.12a.5.5 0 0 1 .707 0c.195.194.158.548 0 .706l-2.121 2.122a.5.5 0 0 1-.708 0Z"
      fill="var(--filter-bar-btn-border)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.976 20c-.277 0-.5-.276-.5-.5v-9a.5.5 0 0 1 .5-.5c.276 0 .5.276.5.5v9a.5.5 0 0 1-.5.5Z"
      fill="var(--filter-bar-btn-border)"
    />
  </svg>
);

export default SvgComponent;
